import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { ColumnModel } from "../../../services/api/types/common/models/ColumnModel";
import TableList from "../../../components/organisms/TableList";
import { PendingSignOffsModel } from "../../../services/api/types/medications/models/PendingSignOffsModel";
import { format } from "date-fns";
import Pagination from "ui/molecules/pagination/Pagination";
import usePagination from "ui/molecules/pagination/usePagination";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { ChevronRightIcon } from "ui/gluestack/icon";
import { useRouter } from "expo-router";
import { MobileTableCard } from "../../../components/organisms/MobileTableCard";
import { useHandleChecklistPendingSignOffs } from "../../reporting/hooks/useHandleChecklistPendingSignOffs";

export default function AdmissionChecklistTemplate() {
  const router = useRouter();
  const { currentPage, handlePageChange } = usePagination();
  const { data, isLoading } = useHandleChecklistPendingSignOffs({
    currentPage,
  });
  const columns: ColumnModel<PendingSignOffsModel>[] = [
    {
      title: "Resident",
      dataKey: "resident_name",
      renderCell: (item: PendingSignOffsModel) => (
        <View>
          <Text className="text-base text-typography-900 font-medium">
            {item.resident_name}
          </Text>
        </View>
      ),
    },
    {
      title: "Submitted by",
      dataKey: "created_by",
      renderCell: (item: PendingSignOffsModel) => (
        <View>
          <Text className="text-base text-typography-900 font-medium">
            {`${item.created_by.first_name} ${item.created_by.last_name}`}
          </Text>
        </View>
      ),
    },
    {
      title: "Date/Time",
      dataKey: "created_at",
      renderCell: (item: PendingSignOffsModel) => (
        <View>
          <Text className="text-base text-typography-900 font-medium">
            {format(new Date(item.created_at), "dd-MM-yyyy HH:mm")}
          </Text>
        </View>
      ),
    },
    {
      colSpan: 1,
      renderCell(item) {
        return (
          <Button
            variant="link"
            size="sm"
            onPress={() =>
              router.push(`/residents/${item.resident_id}/admission`)
            }
          >
            <ButtonText>Review</ButtonText>
            <ButtonIcon as={ChevronRightIcon} />
          </Button>
        );
      },
    },
  ];
  return (
    <View>
      <TableList
        columns={columns}
        data={data?.data || []}
        emptyMessage="There are no pending items to sign off."
        showHorizontalRowDivider
        showHorizontalHeaderDivider
        isFetching={isLoading}
        onRowPress={(item) =>
          router.push(`/residents/${item.resident_id}/admission`)
        }
        mobileRenderItem={(item) => (
          <MobileTableCard item={item} columns={columns} key={item.id} />
        )}
      />
      <Pagination meta={data?.meta} onPageChange={handlePageChange} />
    </View>
  );
}
